/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tab': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M622.277 39.385H401.723c-13.785 0-23.63 11.815-23.63 25.6v49.23c0 13.785 11.815 25.6 23.63 25.6h220.554c13.785 0 23.63-11.815 23.63-25.6v-49.23c1.97-13.785-9.845-25.6-23.63-25.6zm336.738 0H738.462c-13.785 0-25.6 11.815-25.6 25.6v49.23c0 13.785 11.815 25.6 25.6 25.6h220.553c13.785-1.969 25.6-11.815 25.6-25.6v-49.23c0-13.785-11.815-25.6-25.6-25.6zm0 165.415H334.77c-13.784 0-25.6-11.815-25.6-25.6V64.985c0-13.785-11.815-25.6-25.6-25.6H64.985c-13.785 0-25.6 11.815-25.6 25.6v896c0 11.815 11.815 23.63 25.6 23.63h894.03c13.785 0 25.6-11.815 25.6-25.6V230.4c0-13.785-11.815-25.6-25.6-25.6z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/tab.js